<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="species">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="light-blue darken-4">
                        <v-toolbar-title>Catálogo de especies&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewSpecies"
                            >Nueva Especie</v-btn>
                            <v-btn
                                :disabled="(bEdit || speciesID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteSpecies"
                            >Borrar Especie</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewSpecies">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-plus</v-icon>&nbsp; Nueva Especie
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteSpecies">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-minus</v-icon>&nbsp; Borrar Especie
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de especies y especie seleccionada: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para lista de especies y card de especie seleccionada: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Especies: *************************** -->
                            <v-flex xs10 sm3>
                                <v-card>
                                    <v-toolbar dense color="light-blue darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Especies Registradas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedSpeciesIndex"
                                            color="pink accent-3"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(especie, i) in species"
                                                :key="i"
                                                @click="selectSpecies(especie.especieid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ especie.especie }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Especies ********************************* -->

                            <!-- Info de la especie seleccionada: *********************** -->
                            <v-flex xs10 sm9>
                                <v-card class="grey lighten-3">
                                     <v-toolbar dense color="light-blue lighten-1" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedSpeciesName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-dog-side</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid grid-list-xl>
                                            <v-layout>
                                                <v-flex xs12>
                                                    <v-card>
                                                        <v-card-title class="light-blue--text text--darken-4">
                                                            Nombre de la Especie
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        @click="onEditSpeciesName"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-pencil</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Editar el nombre del la especie</span>
                                                            </v-tooltip>
                                                        </v-card-title>

                                                        <v-card-text>

                                                            <v-data-table
                                                                fixed-header
                                                                :headers="speciesTableHeader"
                                                                :items="speciesNameTable"
                                                                item-key="especieidiomaid"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text=""
                                                                :show-select="false"
                                                                single-select
                                                                dense
                                                            ></v-data-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                             <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-card class="mx-auto teal--text text--darken-3">
                                                        <v-toolbar height="30" color="light-blue lighten-1" flat>
                                                            <v-icon mdi-paw></v-icon>
                                                            <v-toolbar-title class="my-list-title">&nbsp; Razas</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-toolbar-items>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="bEdit" @click="onNewBreed" v-on="on">
                                                                            <v-icon>mdi-plus</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Nueva raza</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="bEdit || selectedBreed.length === 0" @click="onEditBreed" v-on="on">
                                                                            <v-icon>mdi-pencil</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Editar raza</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="bEdit || selectedBreed.length === 0" @click="onDeleteBreed" v-on="on">
                                                                            <v-icon>mdi-delete</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Borrar raza</span>
                                                                </v-tooltip>
                                                            </v-toolbar-items>
                                                        </v-toolbar>

                                                        <!-- :items-per-page="breedTable.length" -->
                                                        <!-- items-per-page="10" -->
                                                        <v-data-table
                                                            fixed-header
                                                            :headers="speciesTableHeader"
                                                            :items="breedTable"
                                                            item-key="razaid"
                                                            v-model="selectedBreed"
                                                            locale="es-MX"
                                                            class="elevation-1"
                                                            show-select
                                                            single-select
                                                            dense
                                                            no-data-text="No hay razas registradas para esta especie"
                                                            
                                                            :footer-props="{
                                                                'items-per-page-options':[(breedTable.length < 21 ? breedTable.length: 20)],
                                                                'disable-items-per-page': true,
                                                            }"
                                                            
                                                        >
                                                        </v-data-table>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de especie seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de especie: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingSpecies" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Especie</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la especie {{ selectedSpeciesName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteSpeciesConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteSpecies"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de especie *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange accent-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Especies</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay especies registradas con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->


                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para indicar que ya existe otra especie registrada con el mismo nombre: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="duplicatedSpeciesError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Especie Duplicada</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >Ya existe otra especie registrada con el mismo nombre</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onDuplicatedSpecies"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para indicar que ya existe otra especie registrada con el mismo nombre *********************************** -->

                        <!-- Modal para editar el nombre de la especie: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditSpeciesName"
                                persistent
                                max-width="40%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="light-blue lighten-2" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Nombre de la especie</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                v-for="(name, i) in speciesNameArray"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="name.languageName"
                                                        type="text"
                                                        required
                                                        v-model="name.name"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSpeciesNameEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSpeciesNameEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar el nombre de la especie *************************** -->

                        <!-- Modal para informar que hay un error en la edición del nombre de una raza: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgSpeciesError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Error en la edición de una especie</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >{{ speciesError }}</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgSpeciesError = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que hay un error en la edición del nombre de una especie *********************************** -->

                        <!-- Modal para editar el nombre de una raza: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditBreed" persistent max-width="50%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="light-blue lighten-2" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Nombre de la raza</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-comment-edit</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                row
                                                v-for="(breed, i) in breedLangArray"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="breed.languageName"
                                                        type="text"
                                                        required
                                                        v-model="breed.breedName"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmEditBreed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelEditBreed"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar el nombre de una raza *************************** -->

                        <!-- Modal para informar que hay un error en la edición del nombre de una raza: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditBreedError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Error en la edición de una raza</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >{{ breedsError }}</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgEditBreedError = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que hay un error en la edición del nombre de una raza *********************************** -->

                        <!-- Modal para confirmar borrado de raza: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDeletingBreed"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="orange darken-4"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar Raza</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-dog-side-off</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon
                                                large
                                                color="orange darken-2"
                                                >mdi-alert</v-icon
                                            >
                                        </div>
                                        &nbsp; {{ breedToDelete }}
                                    </v-card-title>
                                     <v-card-text class="text-center" >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeleteBreed"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteBreed"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de raza *************************** -->

                        <!-- Termina renglón único para lista de especies y especie seleccionada -->
                    </v-container>
                    <!-- Termina container para lista de especies y especie seleccionada -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'species',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,

            bInvalidData: false,
            errorMessage: '',
            speciesID: 0,
            selectedBreed: [],
            speciesNameArray: [], //Arreglo con el nombre de la especie en todos los idiomas.
            breedLangArray: [], //Arreglo con el nombre de la raza seleccionada en todos los idiomas.
            editingBreedID: 0,

            selectedSpeciesName: '',
            bDeletingSpecies: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            bDlgEditSpeciesName: false,
            bNewBreed: false,
            bDlgEditBreed: false,
            breedsError: '',
            speciesError: '',
            bDlgEditBreedError: false,
            bDlgSpeciesError: false,
            breedToDelete: '',
            bDeletingBreed: false,
        };
    },
    created() {
        this.selectFirstSpecies();
    },

    methods: {
        onClose() {
            this.$router.push('/');
        },

        onNewSpecies() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedSpeciesName = 'Nueva Especie';
            this.selectedSpeciesIndex = -1;
            this.speciesID = 0;

            //Se crea un arreglo para contener el nombre de la especie en todos los idiomas:
            this.speciesNameArray = [];
            for (let i = 0; i < this.languages.length; i ++)
            {
                var name = {
                    name: '',
                    languageID: this.languages[i].idiomaid,
                    languageName: this.languages[i].idioma
                }
                this.speciesNameArray.push(name);
            }

            this.bDlgEditSpeciesName = true;
        },

        onDeleteSpecies() {
            this.bDeletingSpecies = true;
        },

        cancelDeleteSpecies() {
            this.bDeletingSpecies = false;
        },

        deleteSpeciesConfirmed() {
            this.bDeletingSpecies = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.species.length; i++)
            {
                if (this.species[i].especieid === this.speciesID)
                {
                    this.species.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteSpecies', this.speciesID);
            this.selectFirstSpecies();
        },

        // onCancel() {
        //     if (this.bNew) {
        //         //Selecciona la primer especie de la lista:
        //         this.selectFirstSpecies();
        //         this.bNew = false;
        //     } else {
        //         //Vuelve a obtener los datos originales de la especie seleccionada:
        //         this.selectSpecies(this.speciesID);
        //     }
        //     this.bEdit = false;
        // },

        selectFirstSpecies()
        {
            if (this.species.length > 0)
            {
                this.selectedSpeciesIndex = 0;
                var speciesID = this.species[this.selectedSpeciesIndex].especieid;
                this.selectSpecies(speciesID);
            }
            else
            {
                this.selectedSpeciesIndex = -1;
                this.speciesID = 0;
            }
        },
        selectSpecies(speciesID)
        {
            console.log("selectSpecies, speciesID = ", speciesID);
            var i;
            for (i = 0; i < this.species.length; i++)
            {
                if (this.species[i].especieid === speciesID)
                {
                    this.speciesID = speciesID;

                    this.selectedSpeciesName = this.species[i].especie;
                    this.$store.dispatch('getSpeciesData', speciesID);

                    break;
                }
            }
        },
        onSearch()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.species.length; i++)
                {
                    var strLowerCaseText = this.species[i].especie.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedSpeciesIndex = i;
                        this.selectSpecies(this.species[i].especieid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        onDuplicatedSpecies()
        {
            this.duplicatedSpeciesError = false;
            this.selectedSpeciesName = 'Nueva Especie';
            this.bEdit = true;
            this.bNew = true;
        },

        onEditSpeciesName(){
            //Se crea un arreglo con el nombre de la especie en todos los idiomas:
            this.speciesNameArray = [];
            for (let i = 0; i < this.speciesNames.length; i ++)
            {
                var name = {
                    name: this.speciesNames[i].especie,
                    languageID: this.speciesNames[i].idiomaid,
                    languageName: ''
                };
                for (let j = 0; j < this.languages.length; j ++)
                {
                    if (this.speciesNames[i].idiomaid === this.languages[j].idiomaid)
                    {
                        name.languageName = this.languages[j].idioma;
                        break;
                    }
                }
                this.speciesNameArray.push(name);
            }

            this.bDlgEditSpeciesName = true;
        },

        onCancelSpeciesNameEdition(){

            if (this.bNew)
            {
                 //Selecciona la primer especie de la lista:
                this.selectFirstSpecies();
                this.bNew = false;
            }
            this.bDlgEditSpeciesName = false;
            this.bEdit = false;
        },

        onConfirmSpeciesNameEdition()
        {
            console.log("speciesNameTable = ", this.speciesNameTable);
            console.log("speciesNameArray = ", this.speciesNameArray);
            console.log("speciesNames = ", this.speciesNames);

            //Se checa que exista el nombre en todos los idiomas:
            var bDataOK = true;
            for (let i = 0; i < this.speciesNameArray.length; i ++)
            {
                if (this.speciesNameArray[i].name === '')
                {
                    bDataOK = false;
                    this.speciesError = "Teclee el nombre de la especie en todos los idiomas.";
                    break;
                }
            }

            if (bDataOK)
            {
                if (this.bNew)
                {
                    //Crea el arreglo de los nombres de la especie en los diferentes idiomas:
                    var newSpecies = [];

                    for (let i = 0; i < this.speciesNameArray.length; i ++)
                    {
                        const speciesName = {
                            idiomaid: this.speciesNameArray[i].languageID,
                            especie: this.speciesNameArray[i].name
                        }
                        newSpecies.push(speciesName);

                        //Agrega también la nueva especie en arreglo de todas las especies:
                        this.speciesNames.push(speciesName);
                    }

                    var speciesToSave = {
                        especie: newSpecies
                    };

                    console.log("Species to save: ", newSpecies);

                    this.$store.dispatch('saveNewSpecies', speciesToSave);
                    //Después de este request, hay que volver a pedir la información de la nueva especie
                    //al servidor, para que se genere correctamente la tabla de razas (se generará vacía)
                    this.bNew = false;
                }
                else
                {
                    //Edita el arreglo de los nombres de la especie en los diferentes idiomas:
                    for (let i = 0; i < this.speciesNameArray.length; i ++)
                    {
                        for (let j = 0; j < this.speciesNames.length; j ++)
                        {
                            if (this.speciesNameArray[i].languageID === this.speciesNames[j].idiomaid)
                            {
                                this.speciesNames[j].especie = this.speciesNameArray[i].name;

                                //Se edita el único renglón que tiene la tabla speciesNameTable:
                                const id = this.speciesNameArray[i].languageID;
                                this.speciesNameTable[0][id] = this.speciesNameArray[i].name;
                                break;
                            }
                        }
                    }

                    //Edita el arreglo de la lista de especies:
                    //El nombre que se pondrá será el de la especie del primer idioma registrado:
                    for (let i = 0; i < this.species.length; i ++)
                    {
                        if (this.species[i].especieid === this.speciesID)
                        {
                            this.species[i].especie = this.speciesNameArray[0].name;
                            break;
                        }
                    }

                    const speciesToEdit = {
                        especieid: this.speciesID,
                        especieidiomas: this.speciesNames
                    }

                    this.$store.dispatch('updateSpeciesNames', speciesToEdit);
                }

                //Se pone como título del card la especie en el primer idioma registrado:
                this.selectedSpeciesName = this.speciesNames[0].especie;
                this.bDlgEditSpeciesName = false;
                this.bEdit = false;
            }
            else
            {
                this.bDlgSpeciesError = true;
            }
        },


        onNewBreed(){
            this.editingBreedID = 0;

             //Se crea un arreglo para contener el nombre de la raza en todos los idiomas:
            this.breedLangArray = [];

            for (let i = 0; i < this.languages.length; i ++)
            {
                var breed = {
                    breedName: "",
                    languageID: this.languages[i].idiomaid,
                    languageName: this.languages[i].idioma
                };
                this.breedLangArray.push(breed);
            }

            //console.log('breedLangArray = ', this.breedLangArray);
            this.bNewBreed = true;
            this.bDlgEditBreed = true;

        },

        onCancelEditBreed(){
            this.bNewBreed = false;
            this.bDlgEditBreed = false;
        },

        onEditBreed(){
            //console.log("this.selectedBreed[0] = ", this.selectedBreed[0]);
            this.editingBreedID = this.selectedBreed[0].razaid;

            //Se crea un arreglo con el nombre de la raza en todos los idiomas:
            this.breedLangArray = [];

            for (let i = 0; i < this.breedsLang.length; i ++)
            {
                if (this.breedsLang[i].razaid === this.editingBreedID)
                {
                    var breed = {
                        breedName: this.breedsLang[i].raza,
                        languageID: this.breedsLang[i].idiomaid,
                        languageName: ''
                    };

                    for (let j = 0; j < this.languages.length; j ++)
                    {
                        if (this.breedsLang[i].idiomaid === this.languages[j].idiomaid)
                        {
                            breed.languageName = this.languages[j].idioma;
                            break;
                        }
                    }
                    this.breedLangArray.push(breed);
                }
            }

            //console.log('breedLangArray = ', this.breedLangArray);
            this.bDlgEditBreed = true;
        },

        onConfirmEditBreed(){
            //Checa que haya texto en todos los idiomas:
            var bDataOK = true;
            for (let i = 0; i < this.breedLangArray.length; i ++)
            {
                if (this.breedLangArray[i].breedName === '')
                {
                    bDataOK = false;
                    this.breedsError = "Teclee el nombre de la raza en todos los idiomas.";
                    break;
                }
            }

            if (bDataOK)
            {
                if (this.bNewBreed)
                {
                    //Arreglo con la raza en todos los idiomas que se mandará al servidor:
                    var newBreedsLang = [];

                    //Edita el arreglo de los nombres de la raza en los diferentes idiomas:
                    for (let i = 0; i < this.breedLangArray.length; i ++)
                    {
                        const newBreedLang = {
                            razaid: -1,
                            idiomaid: this.breedLangArray[i].languageID,
                            raza: this.breedLangArray[i].breedName
                        }

                        newBreedsLang.push(newBreedLang);
                    }

                    const newBreed = {
                        especieid: this.speciesID,
                        razasIdiomas: newBreedsLang
                    };

                    console.log('newBreed = ', newBreed);

                    this.$store.dispatch('saveNewBreed', newBreed);
                    //Después de este request, hay que volver a llamar desde store a getSpeciesData, para que la tabla de todas las razas se vuelva a generar.
                }
                else //Edición de raza...
                {
                    //Arreglo con la raza en todos los idiomas que se mandará al servidor:
                    var breedsLangToEdit = [];

                    //Edita el arreglo de los nombres de la raza en los diferentes idiomas:
                    for (let i = 0; i < this.breedLangArray.length; i ++)
                    {
                        for (let j = 0; j < this.breedsLang.length; j ++)
                        {
                            if ((this.breedsLang[j].razaid === this.editingBreedID) &&
                                (this.breedLangArray[i].languageID) === this.breedsLang[j].idiomaid)
                                {
                                    this.breedsLang[j].raza = this.breedLangArray[i].breedName;

                                    const breedLangToEdit = {
                                        razaid: this.breedsLang[j].razaid,
                                        idiomaid: this.breedsLang[j].idiomaid,
                                        raza: this.breedsLang[j].raza
                                    };

                                    breedsLangToEdit.push(breedLangToEdit);

                                    //Se edita la tabla breedTable:
                                    for (let k = 0; k < this.breedTable.length; k ++)
                                    {
                                        if (this.breedTable[k].razaid === this.editingBreedID)
                                        {
                                            const idiomaid = this.breedLangArray[i].languageID;
                                            this.breedTable[k][idiomaid] = this.breedLangArray[i].breedName;
                                            break;
                                        }
                                    }
                                }
                        }
                    }

                    const breedToEdit = {
                        especieid: this.speciesID,
                        razasIdiomas: breedsLangToEdit
                    };

                    console.log("Breed to edit: ", breedToEdit);

                    this.$store.dispatch('updateBreed', breedToEdit);
                }
                this.bNewBreed = false;
                this.bDlgEditBreed = false;
            }
            else
            {
                this.bDlgEditBreedError = true;
            }
        },

        onDeleteBreed(){
            //console.log("selectedBreed = ", this.selectedBreed[0][1]);
            this.breedToDelete = "¿Desea borrar la raza " + this.selectedBreed[0][1] + "?";
            this.bDeletingBreed = true;
        },

        cancelDeleteBreed(){
            this.bDeletingBreed = false;
        },

        confirmDeleteBreed(){
            const breedToDelete = {
                speciesID: this.speciesID,
                breedID: this.selectedBreed[0].razaid
            };
            this.$store.dispatch('deleteBreed', breedToDelete);
            this.selectedBreed = [];
            this.bDeletingBreed = false;
        },
    },
    computed:
    {
        ...mapGetters([
            'waitCursor',
            'species',
            'speciesNames',
            'speciesNameTable',
            'speciesTableHeader',
            'languages',
        ]),
        selectedSpeciesIndex:
        {
            get() {
                return this.$store.getters.selectedSpeciesIndex;
            },
            set(selectedSpeciesIndex) {
                this.$store.dispatch('updateSelectedSpeciesIndex', selectedSpeciesIndex);
            },
        },

        breedsLang: {
            get() {
                return this.$store.getters.breedsLang;
            },
            set(breedsLang) {
                this.$store.dispatch('updateBreedsLang', breedsLang
                );
            }
        },

        breedTable: {
            get() {
                return this.$store.getters.breedTable;
            },
            set(breedTable) {
                this.$store.dispatch('updateBreedTable', breedTable
                );
            }
        },

        newSpeciesID: {
            get() {
                return this.$store.getters.newSpeciesID;
            },
            set(newSpeciesID) {
                this.$store.dispatch('updateNewSpeciesID', newSpeciesID);
            }
        },

        selectNewSpecies: {
            get() {
                return this.$store.getters.selectNewSpecies;
            },
            set(selectNewSpecies) {
                this.$store.dispatch('updateSelectNewSpecies', selectNewSpecies);
            }
        },

        duplicatedSpeciesError:
        {
            get() {
                return this.$store.getters.duplicatedSpeciesError;
            },
            set(duplicatedSpeciesError) {
                this.$store.dispatch('setDuplicatedSpeciesError', duplicatedSpeciesError);
            },
        },

        // style="height: 578px; max-height:100%"
        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs)
            {
                height = '200px';
            }
            else
            if (this.$vuetify.breakpoint.sm)
            {
                height = '700px';
            }
            else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '40';
            } else if (this.$vuetify.breakpoint.md) {
                height = '50';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '60';
            } else {
                height = '80';
            }
            return height;
        },
    },

    watch: {
        selectNewSpecies: function(value, oldValue){
            if (this.selectNewSpecies){
                //Cuando se registra una nueva especie, hay que esperar a que el servidor
                //devuelva el ID para poder seleccionarla (porque se tienen que generar las
                //tablas dinámicas), y también hay que esperar a que la lista completa de
                //todas las especies ya esté devuelta:
                console.log("selectNewSpecies changed, and  newSpeciesID = ", this.newSpeciesID);
                this.selectSpecies(this.newSpeciesID);
                this.selectNewSpecies = false;
                this.newSpeciesID = 0;
            }
        },
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.species {
    background: url('../assets/fondo2.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>